import AddProductDetailsDialogModule from './AddProductDetailsDialog.module';

export * from './AddProductDetailsDialogModuleProps';
export default AddProductDetailsDialogModule;
